export default __webpack_public_path__ + "static/media/ressourceshumaines.6660bbf9.jpg";